import { buildRootURL } from '@centric-os/helpers';

export enum DeliveryBoardRouteNames {
  DELIVERY_BOARD = 'DeliveryBoard',
}

/** Public, unauthenticated runner board. Site id is a path param. */
export const DeliveryBoardRoutePath = buildRootURL('public/delivery-board/:siteId');
